import { t } from '../../i18n.es.js';
import React from 'react';
import { styled, Currency } from '@teko/ui';
import { TableDivider } from '../TableDivider/TableDivider.es.js';

const OrderPromo = styled.table`
  background-color: white;
  border-radius: 8px;
  margin-top: 16px;
  width: 100%;
  border-spacing: 0;

  thead th {
    font-size: 16px;
    font-weight: 500;
    color: #333;
  }

  td,
  th {
    padding: 16px;
  }
`;
const TableHead = styled.th(({ direction, pdLeft = false }) => `
    padding-left: ${pdLeft ? "116px" : ""};
    text-align: ${direction};
    font-weight: 700 !important;
  `);
const TableDataPromo = styled.td`
  padding-left: 116px;
`;
const Price = styled.td`
  text-align: right;
`;
const TableData = styled.td(({ direction }) => `
  text-align: ${direction}
`);
const PromoTable = ({
  promos
}) => {
  return /* @__PURE__ */ React.createElement(OrderPromo, null, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement(TableHead, {
    direction: "left",
    pdLeft: true
  }, t("Khuy\u1EBFn m\xE3i cho \u0111\u01A1n h\xE0ng")), /* @__PURE__ */ React.createElement(TableHead, {
    direction: "right"
  }, t("Gi\xE1 tr\u1ECB")), /* @__PURE__ */ React.createElement(TableHead, {
    direction: "center"
  }, t("S\u1ED1 l\u01B0\u1EE3ng")), /* @__PURE__ */ React.createElement(TableHead, {
    direction: "right"
  }, t("T\u1EA1m t\xEDnh")))), /* @__PURE__ */ React.createElement("tbody", null, promos.map(({ name, price, quantity, total = 0 }, index) => /* @__PURE__ */ React.createElement(React.Fragment, {
    key: index
  }, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement(TableDataPromo, null, name), /* @__PURE__ */ React.createElement(Price, null, /* @__PURE__ */ React.createElement(Currency, {
    value: price,
    space: true,
    underline: true
  })), /* @__PURE__ */ React.createElement(TableData, {
    direction: "center"
  }, quantity), /* @__PURE__ */ React.createElement(TableData, {
    direction: "right"
  }, /* @__PURE__ */ React.createElement(Currency, {
    value: total,
    space: true,
    underline: true
  }))), index !== promos.length - 1 && /* @__PURE__ */ React.createElement(TableDivider, {
    colCount: 4,
    ml: 16,
    mr: 16
  })))));
};

export { PromoTable };
